
import { Drawer, Button } from 'element-ui';
import { ChevronRightIcon } from 'vue-feather-icons';
export default {
  components: {
    ChevronRightIcon,
    Drawer,
    Button,
  },
  props: {
    points: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  // Translations moved to i18n/fr.js, i18n/en.js, and i18n/de.js
};
